import { Modal, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface DeleteModalProps {
    open: boolean;
    header: string;
    onClose: () => void;
    handleDelete: () => void;
}

export default function DeleteConfirmationModal({
    open,
    header,
    onClose,
    handleDelete,
}: DeleteModalProps) {
    return (
        <Modal
            className="modal deleteConfirmation_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>{header}</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <div className="confirmation_text">
                        <p>Are you sure you want to proceed with this action?</p>
                    </div>

                    <div className="footer_btn_flex">
                        <Button
                            className="btn btn_grey"
                            type="button"
                            onClick={onClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="btn btn_primary"
                            type="button"
                            onClick={handleDelete}
                        >
                            Confirm
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
